import { computed } from 'vue'
import type { ComputedRef } from 'vue'

import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

/**
 * Pode LER registros de plantão (`attendance_reading` = emissor+ ∪ perfil Extrator) em algum
 * recurso do ds_attendance — escala, unidade ou empresa, como `useCanEmitAttendance`. É a
 * permissão de `GET containers/:id/audit` e de `GET doctor-stations/:id/records` (spec
 * 2026-09-24 §7.1): sem ela, a seção "Registros do plantão" levaria a um 403 certo.
 *
 * Isto é UX, não segurança: a barreira real é o 403 do backend.
 */
export function useCanReadAttendance(): ComputedRef<boolean> {
  const permissionsStore = usePermissionsStore()
  return computed(() =>
    [
      AuthorizationResourcesAndSubjects.DsAttendance,
      AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit,
      AuthorizationResourcesAndSubjects.DsAttendanceCompany
    ].some((resourceType) =>
      permissionsStore.checkAnyRessources({
        permission: AuthorizationPermissions.AttendanceReading,
        resourceType
      })
    )
  )
}
